// 登入頁
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, auth } from '../api.js';
import { useToast } from '../ui.jsx';

export default function Login() {
  const nav = useNavigate();
  const { toast } = useToast();
  const [f, setF] = useState({ username: '', password: '' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const go = async (e) => {
    e && e.preventDefault();
    if (!f.username || !f.password) { setErr('請輸入帳號同密碼'); return; }
    setBusy(true); setErr('');
    try {
      const r = await api.post('/auth/login', f);
      auth.save(r.token, r.user);
      toast(`歡迎返嚟, ${r.user.display_name || r.user.username}! 👋`);
      nav('/dashboard');
    } catch (e2) { setErr(e2.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="login-shell" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: 26, padding: 20,
    }}>
      <div style={{ textAlign: 'center', position: 'relative' }}>
        <div className="login-mark" style={{
          width: 92, height: 92, margin: '0 auto 16px', borderRadius: 28, fontSize: 44,
          background: 'var(--grad-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: 'inset 0 3px 4px rgba(255,255,255,.5), inset 0 -5px 9px rgba(0,30,90,.25), 0 18px 36px -10px rgba(47,107,255,.55)',
        }}>🏗️</div>
        <h1 style={{ fontSize: 26, fontWeight: 800, letterSpacing: .5 }}>Skycrafter 天神村 工程業務管理系統</h1>
        <p style={{ color: 'var(--ink-2)', marginTop: 6, fontSize: 13.5 }}>請登入以繼續 · 報價 · 訂單 · 發票 · 採購 · 報表</p>
      </div>

      <form className="card" onSubmit={go} style={{ width: '100%', maxWidth: 380, padding: 30 }}>
        <div className="field" style={{ marginBottom: 14 }}>
          <label>帳號 Username</label>
          <input className="input" autoFocus value={f.username} autoComplete="username"
            onChange={e => setF({ ...f, username: e.target.value })} placeholder="你的帳號" />
        </div>
        <div className="field" style={{ marginBottom: 6 }}>
          <label>密碼 Password</label>
          <input className="input" type="password" value={f.password} autoComplete="current-password"
            onChange={e => setF({ ...f, password: e.target.value })} placeholder="••••••" />
        </div>
        {err ? (
          <div style={{ color: 'var(--coral)', fontSize: 12.5, fontWeight: 700, padding: '8px 2px' }}>⚠️ {err}</div>
        ) : null}
        <button className="btn primary" type="submit" disabled={busy}
          style={{ width: '100%', justifyContent: 'center', fontSize: 15, padding: '12px 16px', marginTop: 12 }}>
          {busy ? '登入中…' : '🔓 登入'}
        </button>
      </form>

      <div className="muted">忘記密碼請聯絡系統管理員 (設定 → 帳號管理)</div>
    </div>
  );
}
